import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

interface AdminRouteProps {
  children: ReactNode;
}

export const isAdminUser = (email?: string | null): boolean =>
  !!email && email.endsWith('@go-ecommerce.de');

export const AdminRoute = ({ children }: AdminRouteProps) => {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    // Bereits auf der Login-Seite: nicht erneut umleiten (sonst Redirect-Loop,
    // da die Guard via useLocation bei jeder Location-Aenderung neu rendert und
    // ein wechselndes state.from jede Navigation als neu behandelt wird)
    if (location.pathname === '/login') {
      return null;
    }
    // Unauthentifiziert: zum Login weiterleiten und Ziel-URL merken
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdminUser(user?.email)) {
    // Eingeloggt, aber kein Admin: zum Dashboard weiterleiten
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
